import styled from 'styled-components';

export const Container = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

export const ModalBox = styled.div`
  background: white;
  border-radius: 8px;
  width: 90%;
  height: 95%;
  display: flex;
  flex-direction: column;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
`;

export const Content = styled.div`
  padding: 20px;
  overflow-y: auto;
  flex: 1;
`;

export const StyledDiv = styled.div`
  margin-bottom: 20px;

  h2 {
    color: #007bff;
    margin-bottom: 20px;
    font-size: 1.5rem;
  }

  h3 {
    color: #007bff;
    margin-bottom: 15px;
    font-size: 1.2rem;
  }

  h4 {
    color: #6c757d;
    margin-bottom: 10px;
    font-size: 1rem;
  }
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 20px;

  th, td {
    padding: 12px;
    text-align: left;
    border-bottom: 1px solid #dee2e6;
  }

  th {
    background-color: #f8f9fa;
    font-weight: 600;
    color: #007bff;
  }

  tr:hover {
    background-color: #f8f9fa;
  }
`;

export const TableInput = styled.input`
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #ced4da;
  border-radius: 4px;
  font-size: 14px;

  &:focus {
    outline: none;
    border-color: #007bff;
    box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
  }
`;

export const ModalFooter = styled.div`
  padding: 8px;
  border-top: 1px solid #dee2e6;
  display: flex;
  justify-content: space-between;
  gap: 10px;
  background-color: #f8f9fa;
`;

export const Button = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 20px;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;

  &:disabled {
    opacity: 0.6;
    cursor: default;
  }

  &:not(:disabled):hover {
    opacity: 0.9;
    transform: translateY(-1px);
  }
`;

export const Select = styled.select`
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #ced4da;
  border-radius: 4px;
  font-size: 14px;
  background-color: white;

  &:focus {
    outline: none;
    border-color: #007bff;
    box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
  }
`;

export const CampaignList = styled.div`
  max-height: 500px;
  overflow-y: auto;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  padding: 15px;

  > div {
    margin-bottom: 20px;

    &:last-child {
      margin-bottom: 0;
    }
  }
`;

export const CampaignItem = styled.div`
  padding: 8px 12px;
  background-color: #f8f9fa;
  border-radius: 4px;
  margin-bottom: 5px;
  font-size: 14px;
    color: #212529;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const ScheduleItem = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  margin-bottom: 10px;
  background-color: white;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const ScheduleInput = styled.input`
  flex: 1;
  padding: 8px 12px;
  border: 1px solid #ced4da;
  border-radius: 4px;
  font-size: 14px;

  &:focus {
    outline: none;
    border-color: #007bff;
    box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
  }
`;

export const PercentageInput = styled.input`
  width: 100px;
  padding: 10px 12px;
  border: 1px solid #ced4da;
  border-radius: 4px;
  font-size: 14px;
  text-align: center;
  height: 40px;

  &:focus {
    outline: none;
    border-color: #007bff;
    box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
  }
`;

export const RemoveButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border: none;
  border-radius: 4px;
  background-color: #dc3545;
  color: white;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background-color: #c82333;
    transform: translateY(-1px);
  }
`;

export const AddButton = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  border: none;
  border-radius: 4px;
  background-color: #28a745;
  color: white;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }

  &:not(:disabled):hover {
    background-color: #218838;
    transform: translateY(-1px);
  }
`;

export const CampaignTypeSelect = styled.select`
  min-width: 150px;
  padding: 8px 12px;
  border: 1px solid #ced4da;
  border-radius: 4px;
  font-size: 14px;
  background-color: white;

  &:focus {
    outline: none;
    border-color: #007bff;
    box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
  }
`;

export const CampaignSelect = styled.select`
  min-width: 200px;
  padding: 8px 12px;
  border: 1px solid #ced4da;
  border-radius: 4px;
  font-size: 14px;
  background-color: white;

  &:focus {
    outline: none;
    border-color: #007bff;
    box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
  }

  &:disabled {
    background-color: #e9ecef;
    cursor: not-allowed;
  }
`;

export const CampaignUsageInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 16px;
  padding: 0 12px;
  background-color: #f8f9fa;
  border-radius: 6px;
  border: 1px solid #dee2e6;
  height: 100%;
`;

export const CampaignUsageTitle = styled.div`
  font-weight: bold;
  font-size: 14px;
  color: #495057;
`;

export const CampaignUsageGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
`;

export const CampaignUsageCard = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 10px;
  background-color: ${props => props.isWarning ? '#f8d7da' : '#d1ecf1'};
  border-radius: 4px;
  border: 1px solid ${props => props.isWarning ? '#f5c6cb' : '#bee5eb'};
  font-size: 18px;
`;

export const CampaignUsageWarning = styled.span`
  color: #dc3545;
  font-size: 18px;
`;

export const CampaignUsageLabel = styled.span`
  font-weight: bold;
  color: ${props => props.isWarning ? '#721c24' : '#0c5460'};
`;

export const CampaignUsageCount = styled.span`
  color: ${props => props.isWarning ? '#721c24' : '#0c5460'};
`;

export const CampaignUsageMissing = styled.span`
  color: #dc3545;
  font-weight: bold;
`;

export const ButtonContainer = styled.div`
  display: flex;
  gap: 10px;
`;

export const CampaignPreviewItem = styled(CampaignItem)`
  background-color: ${props => props.isSelected ? '#f8f9fa' : 'white'};
  cursor: default;
  color: ${props => props.isSelected ? '#007bff' : '#212529'};
  opacity: ${props => props.opacity};
  transform: scale(${props => props.scale});
  border: ${props => props.isSelected ? '2px solid #007bff' : '1px solid #dee2e6'};
  box-shadow: ${props => props.isSelected ? '0 4px 12px rgba(0, 123, 255, 0.3)' : '0 2px 4px rgba(0, 0, 0, 0.1)'};
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  margin: 8px 22px;
  border-radius: 8px;
  padding: 12px;
`;

export const CancelButton = styled(Button)`
  background-color: #6c757d;
  border-color: #6c757d;
`;

export const SaveButton = styled(Button)`
  background-color: ${props => props.disabled ? '#6c757d' : '#28a745'};
  border-color: ${props => props.disabled ? '#6c757d' : '#28a745'};
`;
